export default class CSSEffects {

    static createContainer3dFor(item) {
        return $('<div>', {
            css: {
                'left': item.css('left'),
                'top': item.css('top'),
                'width': item.css('width'),
                'height': item.css('height'),
                'position': 'absolute',
                'perspective': item.css('width')
            }
        });
    }

    static createObject3dIn(container3d) {
        return $('<div>', {
            css: {
                'width': '100%',
                'height': '100%',
                'position': 'absolute',
                'transform-style': 'preserve-3d',
                'transition': 'all 1.0s ease-in-out'
            }
        }).appendTo(container3d);
    }

    static createFrontFaceOf(item) {
        let face = $(item).clone();
        face.css({
            'left': '0',
            'top': '0',
            'width': '100%',
            'height': '100%',
            'position': 'absolute',
            'backface-visibility': 'hidden'
        });
        return face;
    }

    static createBackFaceOf(item) {
        let face = $(item).clone();
        face.css({
            'left': 0,
            'top': 0,
            'width': '100%',
            'height': '100%',
            'position': 'absolute',
            'display': 'block',
            'backface-visibility': 'hidden',
            'transform': 'rotateY(180deg)'
        });
        return face;
    }

    static flip(item, degrees, face, before, after) {
        let container3d = CSSEffects.createContainer3dFor(item);
        let object3d = CSSEffects.createObject3dIn(container3d);
        face.appendTo(object3d);

        container3d.insertAfter(item);
        before();
        object3d.one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', () => {
            after();
            container3d.remove();
        });
        setTimeout(() => object3d.css('transform', `rotateY(${degrees}deg)`), 100);
    }

    static hideFlip(item, degrees) {
        CSSEffects.flip(item, degrees, CSSEffects.createFrontFaceOf(item), () => { item.hide(); }, () => {});
    }

    static hideFlipLeft(item) {
        CSSEffects.hideFlip(item, 180);
    }

    static hideFlipRight(item) {
        CSSEffects.hideFlip(item, -180);
    }

    static showFlip(item, degrees) {
        CSSEffects.flip(item, degrees, CSSEffects.createBackFaceOf(item), () => {}, () => { item.show(); });
    }

    static showFlipLeft(item) {
        CSSEffects.showFlip(item, 180);
    }

    static showFlipRight(item) {
        CSSEffects.showFlip(item, -180);
    }

}
